import { registerComponent } from '@gig/magic-common';
import StaticPageHeaderComponent from './static-page-header.vue.js';

var StaticPageHeader = registerComponent(StaticPageHeaderComponent);

export { StaticPageHeader };
